import * as consts from './base/consts'
import format, { FORMAT } from './core/format'
/**
 * 分管各个模块的数据管理类
 */
import { BASE_DATA_MANAGER } from './manager/basedatamng'
import { SETTING_DATA_MANAGER } from './manager/settingdatamng'
import { INFORM_DATA_MANAGER } from './manager/informdatamng'
import { COLLATE_DATA_MANAGER } from './manager/collatedatamng'
import { RECORD_DATA_MANAGER } from './manager/recorddatamng'
import { GROUP_DATA_MANAGER } from './manager/groupdatamng'
import { LABEL_DATA_MANAGER } from './manager/labeldatamng'
import { FATE_DATA_MANAGER } from './manager/fatedatamng'
import { SEARCH_DATA_MANAGER } from './manager/searchdatamng'
import { COMMENT_DATA_MANAGER } from './manager/commentdatamng'
import { OTHER_COMMENT_DATA_MANAGER } from './manager/othercommentdatamng'
import { DISCUSS_DATA_MANAGER } from './manager/discussdatamng'
import { DONATE_DATA_MANAGER } from './manager/donatedatamng'
import { REPORT_DATA_MANAGER } from './manager/reportdatamng'
import { FAMOUS_PEDIA_DATA_MANAGER } from './manager/famouspediadatamng'
/**
 * 处理前端展示数据
 * 定义后端数据转换成前端数据结构的方法
 */
var DATA = {
    /**
     * 获取排盘的分享文字内容
     * @param {是否匿名分享} hideName 
     * @param {命盘数据} data 
     */
    getSharedTextByData(type, hideName, data) {
        var text = '';
        var sexStr = data.sex == 0 ? '乾男：' : '坤女：';
        var nameList = consts.CONST_SHARE_NAME_LIST;
        var newName = nameList[Math.floor(Math.random() * nameList.length)];
        var name = hideName ? newName : data.f_name;
        text += sexStr;
        text += name;
        if(type == 'wechat') { text += '.\n'; }
        if(type == 'qq') { text += '.\n'; }
        // 第二行:八字
        var arr = FORMAT.getEightWordArrByData(data.unknown, data);
        for (var i = 0; i < arr.length; i++) {
            text += arr[i][0].text;
            text += arr[i][1].text;
            text += ' ';
        }
        return text;
    },
    /**
     * 获取自己的批盘的分享文字内容
     * @param {当前用户的信息} userInfo 
     * @param {命盘数据} data 
     */
    getPipanSharedTextByData(type, userInfo, data) {
        // console.log('getPipanSharedTextByData------', userInfo, data)
        var text = '';
        var sexStr = data.sex == 0 ? '乾男：' : '坤女：';
        var pipanStr = userInfo && userInfo.info ? userInfo.info.nickname : '某某某';
            pipanStr = pipanStr ? pipanStr.slice(0, 5) : '某某某';
        text += (pipanStr + '批盘：');
        text += data.f_name ? data.f_name.slice(0, 5) : '';
        if(type == 'wechat') { text += '.\n'; }
        if(type == 'qq') { text += '.\n'; }
        text += sexStr;
        // 八字
        var arr = FORMAT.getEightWordArrByData(data.unknown, data);
        for (var i = 0; i < arr.length; i++) {
            text += arr[i][0].text;
            text += arr[i][1].text;
            text += ' ';
        }
        return text;
    },
    /**
     * 获取他人的批盘的分享文字内容
     * @param {他人批盘的标题} shareTitle 
     * @param {命盘数据} data 
     */
    getOtherPipanShareTextByData(type, shareTitle, data) {
        // console.log('getOtherPipanShareTextByData-----', shareTitle, data)
        var text = '';
        var sexStr = data.sex == 0 ? '乾男：' : '坤女：';
        text += shareTitle;
        if(type == 'wechat') { text += '.\n'; }
        if(type == 'qq') { text += '.\n'; }
        text += sexStr;
        var arr = FORMAT.getEightWordArrByData(data.unknown, data);
        for (var i = 0; i < arr.length; i++) {
            text += arr[i][0].text;
            text += arr[i][1].text;
            text += ' ';
        }
        return text;
    },

    /**
     * 获取论盘的分享文字内容
     * @param {论盘的标题} shareTitle 
     * @param {命盘数据} data 
     */
    getLunPanShareTextByData(type, shareTitle, data) {
        var text = '';
        var sexStr = data.sex == 0 ? '乾男：' : '坤女：';
        shareTitle = shareTitle;
        text += shareTitle;
        if(type == 'wechat') { text += '.\n'; }
        if(type == 'qq') { text += '.\n'; }
        text += sexStr;
        var arr = FORMAT.getEightWordArrByData(data.unknown, data);
        for (var i = 0; i < arr.length; i++) {
            text += arr[i][0].text;
            text += arr[i][1].text;
            text += ' ';
        }
        return text;
    },
    /**
     * 获取百科的分享文字内容
     * @param {八字数据} data 
     */
    getFamousPediaShareTextByData(type, data) {
        var text = '名人八字百科:';
            text += data.f_name;
        if(type == 'wechat') { text += '.\n'; }
        if(type == 'qq') { text += '.\n'; }
        var arr = FORMAT.getEightWordArrByData(data.unknown, data);
        for (var i = 0; i < arr.length; i++) {
            text += arr[i][0].text;
            text += arr[i][1].text;
            text += ' ';
        }
        return text;
    }
}


export {
    DATA,
    BASE_DATA_MANAGER,
    SETTING_DATA_MANAGER,
    INFORM_DATA_MANAGER,
    COLLATE_DATA_MANAGER,
    RECORD_DATA_MANAGER,
    GROUP_DATA_MANAGER,
    LABEL_DATA_MANAGER,
    FATE_DATA_MANAGER,
    SEARCH_DATA_MANAGER,
    COMMENT_DATA_MANAGER,
    OTHER_COMMENT_DATA_MANAGER,
    DISCUSS_DATA_MANAGER,
    DONATE_DATA_MANAGER,
    REPORT_DATA_MANAGER,
    FAMOUS_PEDIA_DATA_MANAGER
}